// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

// Libraries
import { Observable } from 'rxjs';

// Service

// Models
import { AppCleanup } from '../models';
import { ErrorRouteData } from '../../modules/error/models/error-route-data.model';

// Enums
import { EnvironmentType } from '../enums/environment-type.enum';

@Injectable()
export class EnvironmentGuard extends AppCleanup {
	constructor(private router: Router) {
		super();
	}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const permittedEnvironments = route.data.permittedEnvironments;
		let allowAccess = false;

		if (!permittedEnvironments) {
			return true;
		}

		if (permittedEnvironments.includes(EnvironmentType.PORTAL) && permittedEnvironments.includes(EnvironmentType.VIEWER) && permittedEnvironments.includes(EnvironmentType.EDGE)) {
			allowAccess = true;
		} else if (permittedEnvironments.includes(EnvironmentType.PORTAL) && permittedEnvironments.includes(EnvironmentType.VIEWER)) {
			if (this.isPortal || this.isViewer) {
				allowAccess = true;
			}
		} else if (permittedEnvironments.includes(EnvironmentType.PORTAL) && permittedEnvironments.includes(EnvironmentType.EDGE)) {
			if (this.isPortal || this.isEdge) {
				allowAccess = true;
			}
		} else if (permittedEnvironments.includes(EnvironmentType.VIEWER) && permittedEnvironments.includes(EnvironmentType.EDGE)) {
			if (this.isViewer || this.isEdge) {
				allowAccess = true;
			}
		} else if (permittedEnvironments.includes(EnvironmentType.PORTAL)) {
			if (this.isPortal) {
				allowAccess = true;
			}
		} else if (permittedEnvironments.includes(EnvironmentType.VIEWER)) {
			if (this.isViewer) {
				allowAccess = true;
			}
		} else if (permittedEnvironments.includes(EnvironmentType.EDGE)) {
			if (this.isEdge) {
				allowAccess = true;
			}
		} else {
		}

		if (!allowAccess) {
			let errorRouteData: ErrorRouteData = {
				code: 403,
			};

			this.router.navigate(['/error-page'], { queryParams: errorRouteData });
			return false;
		} else {
			return true;
		}
	}

	canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const permittedEnvironments = route.data.permittedEnvironments;

		if (this.isViewer || this.isEdge) {
			let errorRouteData: ErrorRouteData = {
				code: 403,
			};

			this.router.navigate(['/error-page'], { queryParams: errorRouteData });
			return false;
		} else {
			return true;
		}
	}
}
